var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "merchant"
  }, [_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'created_at' ? _c('div', [_vm._v(" " + _vm._s(_vm.formatDate(entry[column.field])) + " ")]) : column.field === 'survey_schedule_at' ? _c('div', [_vm._v(" " + _vm._s(_vm.formatDate(entry[column.field], true)) + " ")]) : column.field === 'fleet_types' || column.field === 'logistic_fields' ? _c('div', [_vm._v(" " + _vm._s(entry[column.field].join(", ")) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }])
  }), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }